module.exports = __webpack_public_path__ + "img/great.a251d02f.svg";